import {getAllPolicyRefundsUrl, getPolicyPeopleUrl, updateBankRefUrl} from "./EndpointService.js";
import {API_METHODS, apiFetch, policyApiFetch} from "./ApiService.js";


export const getAllRefunds = async (token_arg) => {
    try {
        return await policyApiFetch(`${getAllPolicyRefundsUrl}?per_page=1`, token_arg).then(async (response) => {
            return await policyApiFetch(`${getAllPolicyRefundsUrl}?per_page=${response.total !== 0 ? response.total : 1}`, token_arg);
        });
    } catch (error) {
        return null;
    }
};

export const getCountRefunds = async (token_arg) => {
    try {
        return await policyApiFetch(`${getAllPolicyRefundsUrl}?per_page=1`, token_arg)
    } catch (error) {
        return null;
    }
};

export const getBankRefByHolder = async (token_arg, id) => {
    try {
        return await policyApiFetch(`${getPolicyPeopleUrl}/${id}/bank_ref`, token_arg);
    } catch (error) {
        return null;
    }
};

export const updateBankRef = async (token_arg, body) => {
    try {
        return await apiFetch(updateBankRefUrl, token_arg, API_METHODS.POST, body);
    } catch (error) {
        return null;
    }
};

export const confirmRefund = async (token_arg, id) => {
    const body = {
        "stage": "confirmed"
    };
    try {
        return await policyApiFetch(`${getAllPolicyRefundsUrl}/${id}`, token_arg, API_METHODS.PATCH, body);
    } catch (error) {
        return null;
    }
}
